'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("mktHistoryCalendarCarousel", function (contextService) {
  var MIN_CALENDAR_WIDTH = 360;
  return {
    restrict: "E",
    replace: true,
    scope: {
      indexationRef: "=",
      calendarDate: "="
    },
    controllerAs: "carouselCtrl",
    template: require('./mktHistoryCalendarCarousel.html'),
    link: function link($scope, $el, $attrs, ctrl) {
      ctrl.initialize();
    },
    controller: function controller($scope, $element) {
      var ctrl = this;
      var nbMonthsToShow,
        currentDate = null; // this is actually a moment, not a date.

      ctrl.initialize = function () {
        /*
        var context           = contextService.getContext(),
            dateVisualisation = context.dateVisualisation;
        currentDate = moment(dateVisualisation).clone();
        */

        nbMonthsToShow = calculateNumberOfCalendars();
        $scope.$watch("calendarDate", onCalendarDateChange);
        $scope.$on("$resize", function () {
          refreshCalendarsOnResize();
        });
      };
      ctrl.showPrevious = function () {
        currentDate = currentDate.add(-1, "month");
        generateDisplayedMonths();
      };
      ctrl.showNext = function () {
        currentDate = currentDate.add(1, "month");
        generateDisplayedMonths();
      };
      ctrl.monthTrackKey = function (date) {
        return date.getFullYear() + "-" + date.getMonth();
      };
      function onCalendarDateChange() {
        var nextDate = $scope.calendarDate;
        if (nextDate != null && !moment(nextDate).isSame(currentDate, "month")) {
          currentDate = moment(nextDate);
          generateDisplayedMonths();
        }
      }
      function refreshCalendarsOnResize() {
        var newNbCalendars = calculateNumberOfCalendars();
        if (newNbCalendars !== nbMonthsToShow) {
          nbMonthsToShow = newNbCalendars;
          generateDisplayedMonths();
        }
      }
      function calculateNumberOfCalendars() {
        var totalWidth = $element.innerWidth(),
          buttonsWidth = $element.find(".mkt-carousel-btn").eq(0).width() * 2,
          availableWidth = totalWidth - buttonsWidth,
          nbCalendars = Math.floor(availableWidth / MIN_CALENDAR_WIDTH);
        // console.log("*** calculateNumberOfCalendars ->", nbCalendars, availableWidth);
        return nbCalendars;
      }
      function generateDisplayedMonths() {
        var lastMonth = currentDate.clone(); // TODO : parametrize here.
        var displayedMonths = [];
        for (var i = 0; i < nbMonthsToShow; i++) {
          displayedMonths.unshift(moment(lastMonth).add(-i, "month").toDate());
        }
        ctrl.months = displayedMonths;
      }
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/marche/historique/mktHistoryCalendarCarousel.js
// module id = 2847
// module chunks = 13